import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization - simplified and safer
    try {
      // Check if fbq already exists
      if (window.fbq) return;
      // Create fbq function
      const fbq: any = function () {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, arguments);
        } else {
          fbq.queue.push(arguments);
        }
      };
      // Initialize fbq properties
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      // Assign to window
      window.fbq = fbq;
      // Load the Facebook Pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      }
      // Initialize and track PageView
      window.fbq('init', '1604085974259940');
      window.fbq('track', 'PageView');
      // Add noscript fallback image
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=1604085974259940&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    } catch (error) {
      console.error('Meta Pixel initialization error:', error);
    }
  }, []);
  return <main className="min-h-screen bg-cream selection:bg-copper selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedApproaches data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoIsThisFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <ProofSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <OfferBlock data-id="element-11" />
      <Footer data-id="element-12" />
    </main>;
}